// removed by extract-text-webpack-plugin
module.exports = {"container":"_3j3wPvK","gridItem":"_3V0KF--","gridItem__sale":"_3fZXQRD","gridItemImageBorder":"_2GC-7QL","gridItemImage":"_38TV2Q5"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Navigation/LargeSecondaryNavigation/GridCircleImage/index.css
// module id = ./template/components/Navigation/LargeSecondaryNavigation/GridCircleImage/index.css
// module chunks = client.sitechrome